import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { AlertService } from '@app/_services';
import { PropertyService } from '@app/_components/property';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class PropertyResolver  {

	constructor(
		private router: Router,
		private propertyService: PropertyService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.propertyService.findById(+activatedRouteSnapshot.paramMap.get('shortTermRentalId'));
	}
}
